const ROUTES = {
  EVENTS_INSCRIPTION: "/events/inscription",
  HOME: "/",
  LOGIN: "/login",
  PASSWORD_FORGOT: "/password/forgot",
  PASSWORD_NEW: "/password/new",
  CREATE_ACCOUNT: "/account/create",
  MESSAGE: "/message",
  USERS_PRESENT: "/users/present",
  USERS_REGISTERED: "/users/registered",
  SCAN: "/scan",
  BADGE_DOWNLOAD: "/badge/:badgeId/download",
  PHOTOS: "/photos"
}

export default ROUTES
